export const LOADER_STATUS = "boilderplate/TEMPLATE_MAPPING/LOADER_STATUS";
export const headerColumns = [
  {
    value: "Mapping",
    id: 1,
  },
  {
    value: "History",
    id: 2,
  },
];
// Template Mapping Form Action Types
export const SET_ENTITY_NAME = "boilderplate/TEMPLATE_MAPPING/SET_ENTITY_NAME";
export const SET_MODULE_NAME = "boilderplate/TEMPLATE_MAPPING/SET_MODULE_NAME";
export const SET_NAME = "boilderplate/TEMPLATE_MAPPING/SET_NAME";
export const SET_SELECTED_TYPE =
  "boilderplate/TEMPLATE_MAPPING/SET_SELECTED_TYPE";
export const SET_SELECTED_SHEET =
  "boilderplate/TEMPLATE_MAPPING/SET_SELECTED_SHEET";
export const SET_UPLOADED_FILE =
  "boilderplate/TEMPLATE_MAPPING/SET_UPLOADED_FILE";
export const SET_EXCEL_HEADERS =
  "boilderplate/TEMPLATE_MAPPING/SET_EXCEL_HEADERS";
export const SET_ENTITY_LIST = "boilderplate/TEMPLATE_MAPPING/SET_ENTITY_LIST";
export const SET_HISTORY_DATA =
  "boilderplate/TEMPLATE_MAPPING/SET_HISTORY_DATA";
export const SET_MAPPING_DATA =
  "boilderplate/TEMPLATE_MAPPING/SET_MAPPING_DATA";
export const SET_EDIT_MODE = "boilderplate/TEMPLATE_MAPPING/SET_EDIT_MODE";
export const SET_EDIT_DATA = "boilderplate/TEMPLATE_MAPPING/SET_EDIT_DATA";
export const RESET_TEMPLATE_MAPPING =
  "boilderplate/TEMPLATE_MAPPING/RESET_TEMPLATE_MAPPING";
export const CLEAR_FORM_FIELDS =
  "boilderplate/TEMPLATE_MAPPING/CLEAR_FORM_FIELDS";


